import { render } from "./ModalChooseUsers.vue?vue&type=template&id=31365060&scoped=true"
import script from "./ModalChooseUsers.vue?vue&type=script&lang=js"
export * from "./ModalChooseUsers.vue?vue&type=script&lang=js"

import "./ModalChooseUsers.vue?vue&type=style&index=0&id=31365060&scoped=true&lang=css"

import exportComponent from "/home/stagging/consillium/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31365060"]])

export default __exports__